import * as React from "react";
import * as __intl__ from "@frameio/i18n";
import { type MountErrorCode } from "@frameio/graphql-client/generated/types";
export type Text = {
    cannotMountReason: (reason?: MountErrorCode) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            // Reason that a user is unable to mount a project, displayed in tooltips and dialogs
            cannotMountReason: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (reason?: MountErrorCode) => __intl__.intl().formatMessage({ id: "useMountErrorMessage.cannotMountReason?c=29mr8e4e4tmsj", defaultMessage: "{var, select, ACCOUNT_LOCKED {Account is locked.} ACCOUNT_DELINQUENT {Account is delinquent.} NO_MOUNTED_STORAGE_ENTITLEMENT {Mounted Storage is not included in your current plan.} MOUNTED_STORAGE_DISABLED {An administrator has disabled the Mounted Storage feature on this account.} CONTENT_SECURITY_RESTRICTION {Mounted Storage is not available in this workspace because one or more content security features, such as watermarking, have been enabled.} STORAGE_QUOTA_EXCEEDED {Not enough Mounted Storage. Ask an admin to try moving some projects to Standard Storage to free up space.} PROJECT_LOCKED {This project can\u2019t be opened on desktop. Admins can allow mounting with Frame.io Drive in Settings.} INSUFFICIENT_PERMISSIONS {You do not have permission to mount this project.} other {You do not have permission to mount this project.}}" }, { var: reason ?? "other" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
